import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { withTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { mdiCalendarBlankOutline, mdiCalendarCheckOutline } from "@mdi/js";
import Icon from "@mdi/react";
import React, { Component } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { languages } from "../../constants/languages";
import Break from "./Break";
import Match from "./Match";

class NotDividedList extends Component {
  state = {
    limitToLast: 20,
  };
  componentDidMount() {
    const notPlannedList = document.getElementById("notPlannedList");
    notPlannedList.addEventListener("scroll", this.onScroll);
  }

  componentWillUnmount() {
    const notPlannedList = document.getElementById("notPlannedList");
    notPlannedList.removeEventListener("scroll", this.onScroll);
  }

  onScroll = () => {
    const notPlannedList = document.getElementById("notPlannedList");
    if (
      notPlannedList.scrollTop + notPlannedList.clientHeight >=
      notPlannedList.scrollHeight - 50
    ) {
      this.setState({ limitToLast: this.state.limitToLast + 20 });
    }
  };

  render() {
    let breaks = Object.keys(this.props.tournament.breaks || {})
      .map((key, i) => {
        let tournamentBreak = this.props.tournament.breaks[key];
        tournamentBreak["id"] = key;
        tournamentBreak["isBreak"] = true;
        return tournamentBreak;
      })
      .filter((b) => b.field === null || b.field === undefined);
    return (
      <div
        style={{
          paddingBottom: 10,
          overflowY: "auto",
          height: "calc(100vh - 132px)",
        }}
        id="notPlannedList"
      >
        <Typography variant="h6" style={{ marginTop: 10, padding: "0 10px" }}>
          {languages.schedule.not.charAt(0).toUpperCase() +
            languages.schedule.not.slice(1) +
            " " +
            languages.schedule.planned +
            " (" +
            this.props.matchesToPlan.length +
            "/" +
            this.props.matches.length +
            ")"}
        </Typography>

        <div style={{ width: "100%" }}>
          {!this.props.allMatchesPlanned && (
            <div style={{ width: "100%", marginTop: 10, padding: "0 10px" }}>
              <TextField
                variant="standard"
                placeholder={languages.formatString(
                  languages.schedule.searchTeams,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
                value={this.props.teamSearch}
                onChange={this.props.handleTeamSearch}
                style={{ marginBottom: 16, width: "100%" }}
              />
              <div
                style={{
                  display: "flex",
                  gap: 16,
                  marginBottom: this.props.showSelectRounds ? 16 : 0,
                }}
              >
                <Autocomplete
                  size="small"
                  multiple
                  filterSelectedOptions
                  options={this.props.options}
                  getOptionLabel={(option) => option.label}
                  getOptionSelected={(option) =>
                    this.props.value.find((v) => option.value === v.value) !==
                    undefined
                  }
                  onChange={(e, newValue) => {
                    this.props.handleSelectChange(e, newValue);
                  }}
                  value={this.props.value}
                  renderInput={(params) => {
                    return (
                      <TextField
                        {...params}
                        variant="standard"
                        label={languages.schedule.searchPoules}
                        fullWidth
                      />
                    );
                  }}
                  clearText=""
                  closeText=""
                  openText=""
                  noOptionsText=""
                  style={{ flex: 1 }}
                />
              </div>
              {this.props.showSelectRounds && (
                <FormControl fullWidth>
                  <InputLabel htmlFor="select-rounds-for-poule">
                    {languages.schedule.selectRounds}
                  </InputLabel>
                  <Select
                    fullWidth
                    value={this.props.selectedRoundFilter}
                    onChange={this.props.handleSelectRoundChange}
                    inputProps={{
                      name: "select-rounds-for-poule",
                      id: "select-rounds-for-poule",
                    }}
                  >
                    {this.props.roundOptions.map((n) => (
                      <MenuItem key={n.value} value={n.value}>
                        {n.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </div>
          )}
          <div>
            {this.props.poulesLoaded && this.props.resultSpotsLoaded && (
              <div
                style={{
                  width: "100%",
                }}
              >
                {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 30,
            paddingLeft: 10,
            background: "#e3e4e4",
            borderRadius: 2
          }}
        >
          <Typography style={{ fontWeight: 500 }}>
            {this.props.matchesToPlan.length +
              "/" +
              this.props.matches.length +
              " " +
              languages.schedule.matches.toLowerCase() +
              " " +
              languages.schedule.not +
              " " +
              languages.schedule.planned}
          </Typography>
        </div> */}

                <Droppable droppableId={"emptyDrop"}>
                  {(provided, snapshot) => {
                    return (
                      <div
                        ref={provided.innerRef}
                        style={{
                          height: "100%",
                        }}
                      >
                        {snapshot.isDraggingOver && (
                          <div
                            style={{
                              position: "absolute",
                              backgroundColor: "white",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              zIndex: 20,
                            }}
                          >
                            <Typography
                              variant="h6"
                              style={{
                                marginTop: 150,
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              {languages.schedule.toNotPlanned}
                            </Typography>
                          </div>
                        )}
                        <Droppable droppableId={"empty"} isDropDisabled={true}>
                          {(provided, snapshot) => {
                            return (
                              <div
                                ref={provided.innerRef}
                                style={{
                                  padding: "5px 10px 0",
                                  height: "100%",
                                  overflowY: "hidden",
                                  overflowX: "hidden",
                                }}
                              >
                                {this.props.matchesToPlan.concat(
                                  this.props.selected.length > 0 ? [] : breaks
                                ).length === 0 ? (
                                  this.props.matches.length === 0 ? (
                                    <div
                                      style={{
                                        width: "100%",
                                        textAlign: "center",
                                      }}
                                    >
                                      <Icon
                                        path={mdiCalendarBlankOutline}
                                        size={2}
                                        color={"rgba(0, 0, 0, 0.54)"}
                                        style={{ marginTop: 20 }}
                                      />
                                      <Typography>
                                        {languages.schedule.noMatchesToPlan}
                                      </Typography>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        width: "100%",
                                        textAlign: "center",
                                      }}
                                    >
                                      <Icon
                                        path={mdiCalendarCheckOutline}
                                        size={2}
                                        color={"rgba(0, 0, 0, 0.54)"}
                                        style={{ marginTop: 20 }}
                                      />
                                      <Typography>
                                        {languages.schedule.allMatchesPlanned}
                                      </Typography>
                                    </div>
                                  )
                                ) : (
                                  this.props.matchesToPlan
                                    .concat(
                                      this.props.selected.length > 0
                                        ? []
                                        : breaks
                                    )
                                    .sort((a, b) => {
                                      let aBracket = undefined;
                                      let aPoule =
                                        this.props.poulesByKey[a.poule] || {};
                                      if (aPoule.bracket) {
                                        aBracket =
                                          this.props.bracketsByKey[
                                            aPoule.bracket
                                          ] || {};
                                      }

                                      let bBracket = undefined;
                                      let bPoule =
                                        this.props.poulesByKey[b.poule] || {};
                                      if (bPoule.bracket) {
                                        bBracket =
                                          this.props.bracketsByKey[
                                            bPoule.bracket
                                          ] || {};
                                      }
                                      if (
                                        (aBracket || aPoule || {}).division >
                                        (bBracket || bPoule || {}).division
                                      ) {
                                        return 1;
                                      } else if (
                                        (aBracket || aPoule || {}).division <
                                        (bBracket || bPoule || {}).division
                                      ) {
                                        return -1;
                                      } else if (
                                        (aBracket || aPoule || {}).fase >
                                        (bBracket || bPoule || {}).fase
                                      ) {
                                        return 1;
                                      } else if (
                                        (aBracket || aPoule || {}).fase <
                                        (bBracket || bPoule || {}).fase
                                      ) {
                                        return -1;
                                      } else if (
                                        (aBracket || aPoule || {}).indexNum >
                                        (bBracket || bPoule || {}).indexNum
                                      ) {
                                        return 1;
                                      } else if (
                                        (aBracket || aPoule || {}).indexNum <
                                        (bBracket || bPoule || {}).indexNum
                                      ) {
                                        return -1;
                                      } else if (
                                        (aBracket || aPoule || {}).num >
                                        (bBracket || bPoule || {}).num
                                      ) {
                                        return 1;
                                      } else if (
                                        (aBracket || aPoule || {}).num <
                                        (bBracket || bPoule || {}).num
                                      ) {
                                        return -1;
                                      } else {
                                        return (
                                          (aPoule.bracket
                                            ? aPoule.num
                                            : a.numInPoule) -
                                          (bPoule.bracket
                                            ? bPoule.num
                                            : b.numInPoule)
                                        );
                                      }
                                    })
                                    .slice(0, this.state.limitToLast)
                                    .map((match, i) => {
                                      return (
                                        <Draggable
                                          key={match.id}
                                          draggableId={match.id}
                                          index={i}
                                          isDragDisabled={
                                            this.props.tournament
                                              .scheduleLocked || false
                                          }
                                        >
                                          {(provided, snapshot) => (
                                            <div>
                                              <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                              >
                                                {match.isBreak ? (
                                                  <Break
                                                    tournament={
                                                      this.props.tournament
                                                    }
                                                    break={match}
                                                    teams={this.props.teams}
                                                    teamsByKey={
                                                      this.props.teamsByKey
                                                    }
                                                    eventOptions={
                                                      this.props.eventOptions
                                                    }
                                                    divisionsObject={
                                                      this.props.divisionsObject
                                                    }
                                                    isEvent={
                                                      match.isEvent || false
                                                    }
                                                  />
                                                ) : (
                                                  <Match
                                                    tournament={
                                                      this.props.tournament
                                                    }
                                                    match={match}
                                                    poulesByKey={
                                                      this.props.poulesByKey
                                                    }
                                                    bracketsByKey={
                                                      this.props.bracketsByKey
                                                    }
                                                    resultSpotsAll={
                                                      this.props.resultSpotsAll
                                                    }
                                                    divisions={
                                                      this.props.divisions
                                                    }
                                                    divisionsObject={
                                                      this.props.divisionsObject
                                                    }
                                                    refereesByKey={
                                                      this.props.refereesByKey
                                                    }
                                                    referees={
                                                      this.props.referees
                                                    }
                                                    divisionColors={
                                                      this.props.divisionColors
                                                    }
                                                    groupColors={
                                                      this.props.groupColors
                                                    }
                                                    isDraggingRefereeFromMatch={
                                                      this.props
                                                        .isDraggingRefereeFromMatch
                                                    }
                                                    isDraggingReferee={
                                                      this.props
                                                        .isDraggingReferee
                                                    }
                                                    teams={this.props.teams}
                                                    teamsByKey={
                                                      this.props.teamsByKey
                                                    }
                                                  />
                                                )}
                                              </div>
                                              {provided.placeholder}
                                            </div>
                                          )}
                                        </Draggable>
                                      );
                                    })
                                )}
                                {provided.placeholder}
                              </div>
                            );
                          }}
                        </Droppable>
                        {provided.placeholder}
                      </div>
                    );
                  }}
                </Droppable>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTheme(NotDividedList);
